
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { ITButton, IBadge } from './index.d';

@Component
export default class TButton extends Vue {
  @Prop({
    required: true,
  }) btnConf!: ITButton;

  @Prop({
    type: Boolean,
    default: false,
  }) loading?: boolean;

  @Prop({
    type: Object,
  }) badgeConf?: IBadge;

  get compClass() {
    const preCls: string = this.btnConf.disabled ? 'button-container-disabled' : '';
    const btnLoading: string = this.loading ? 'btn-loading' : '';
    switch (this.btnConf.type) {
      case 'error': return `${preCls} ${btnLoading} button-container-error`;
      case 'primary': return `${preCls} ${btnLoading} button-container-primary`;
      case 'info': return `${preCls} ${btnLoading} button-container-info`;
      default: return '';
    }
  }
}
